import { Controller } from '@hotwired/stimulus';
import Collapse from 'bootstrap/js/dist/collapse';

/**
 * Filterable downloads component.
 */
export default class extends Controller {
    static targets = [
        'accordion',
        'accordionAnchor',
        'content'
    ];

    connect() {
        this.accordionAnchorTarget.addEventListener("mouseenter", this.accordionHoverIn.bind(this));
        this.accordionAnchorTarget.addEventListener("mouseleave", this.accordionHoverOut.bind(this));
    }

    disconnect() {
        this.accordionAnchorTarget.removeEventListener("mouseenter", this.accordionHoverIn.bind(this));
        this.accordionAnchorTarget.removeEventListener("mouseleave", this.accordionHoverOut.bind(this));
    }

    toggle(event) {
        event.preventDefault();

        const content = this.contentTarget;
        const bsCollapse = Collapse.getOrCreateInstance(content, { toggle: false });
        bsCollapse.toggle();

        // Update trigger state
        const anchor = this.accordionAnchorTarget;
        const isExpanded = anchor.getAttribute('aria-expanded') === 'true';

        anchor.setAttribute('aria-expanded', !isExpanded);
        if (isExpanded) {
            anchor.classList.add('collapsed');
        } else {
            anchor.classList.remove('collapsed');
        }
    }

    accordionHoverIn(){
        this.accordionTarget.classList.add('hovered');
    }

    accordionHoverOut(){
        this.accordionTarget.classList.remove('hovered');
    }

}
